import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { BankIDInputMeta, CorporateNameInputMeta } from '../commonMeta';

export interface IPrintOutputFormattingMeta{
  bankID: FormInputMeta;
  corporateName: FormInputMeta;
  firstLine: FormInputMeta,
  secondLine: FormInputMeta,
  thirdLine: FormInputMeta,
  fourthLine: FormInputMeta,
  fifthLine: FormInputMeta,
  sixthLine: FormInputMeta,
  seventhLine: FormInputMeta,
  formFeed: FormInputMeta,
  
  schema: any,
}

const PrintOutputFormattingMeta: IPrintOutputFormattingMeta= {} as IPrintOutputFormattingMeta;

PrintOutputFormattingMeta.bankID = BankIDInputMeta;

PrintOutputFormattingMeta.corporateName = CorporateNameInputMeta;

PrintOutputFormattingMeta.firstLine = {
  label: 'First Line',
  name: 'firstLine',
  type: 'text',
  placeholder: 'First Line',
  validation: yup.string().required(),
}

PrintOutputFormattingMeta.secondLine = {
  label: 'Second Line',
  name: 'secondLine',
  type: 'text',
  placeholder: 'Second Line',
  validation: yup.string().required(),
}

PrintOutputFormattingMeta.thirdLine = {
  label: 'Third Line',
  name: 'thirdLine',
  type: 'text',
  placeholder: 'Third Line',
  validation: yup.string().required(),
}

PrintOutputFormattingMeta.fourthLine = {
  label: 'Fourth Line',
  name: 'fourthLine',
  placeholder: 'Fourth Line',
  type: 'text',
  validation: yup.string().required(),
}

PrintOutputFormattingMeta.fifthLine = {
  label: 'Fifth Line',
  name: 'fifthLine',
  type: 'text',
  placeholder: 'Fith Line',
  validation: yup.string().required(),
}

PrintOutputFormattingMeta.sixthLine = {
  label: 'Sixth Line',
  name: 'sixthLine',
  type: 'text',
  placeholder: 'Sixth Line',
  validation: yup.string().required(),
}

PrintOutputFormattingMeta.seventhLine = {
  label: 'Seventh Line',
  name: 'seventhLine',
  type: 'text',
  placeholder: 'Seventh Line',
  validation: yup.string().required(),
}

PrintOutputFormattingMeta.formFeed = {
  label: 'Form Feed',
  name: 'formFeed',
  type: 'text',
  placeholder: 'Form Feed',
  validation: yup.string().required(),
}

const validationSchema: any = {};

for (let fieldname in PrintOutputFormattingMeta) {
  validationSchema[fieldname] = (PrintOutputFormattingMeta as any)[fieldname].validation;
}

PrintOutputFormattingMeta.schema = yup.object().shape(validationSchema);

export default PrintOutputFormattingMeta;

